import React, { useEffect, useState,useRef } from 'react';
import API from "../Services/API";
import './RegistrationModal.css'; // Import the CSS file for styles
import Snackbar from '@material-ui/core/Snackbar'; // Import Snackbar
import OTPModal from './OTPModal'; // Import the new OTP modal component

const RegistrationModal = ({ isOpen, onClose,ismobile,dbname,groupId,absentStatus,sessionId,therapyDate,lateReason,addToGroup }) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [dob, setDob] = useState('');
    const [error, setError] = useState(null);
    const [dobp, setDobp] = useState('');
    const [gender, setGender] = useState('');
    const [mobile, setMobile] = useState('');
    const [isOTPModalOpen, setIsOTPModalOpen] = useState(false); // State to control OTP modal
    const [email, setEmail] = useState('');
    const [verification, setVerification] = useState('');
    const [otp,setOtp]=useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false); // State to control Snackbar
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const modalContentRef = useRef(null); // Message for Snackbar
    const api = API.create();

    const [errors, setErrors] = useState({}); // State for error messages
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden'; // Prevent scrolling
            if (modalContentRef.current) {
                modalContentRef.current.scrollTop = 0; // Scroll to the top when the modal opens
            }
        } else {
            document.body.style.overflow = 'auto'; // Restore scrolling
        }
    
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen])
    
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden'; // Prevent scrolling
        } else {
            document.body.style.overflow = 'auto'; // Restore scrolling
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);
    const resetFields = () => {
        setFirstName('');
        setLastName('');
        setDob('');
        setGender('');
        setMobile('');
        setEmail('');
        setVerification('');
        setErrors({});
    };
   const handleTextInputChange = (event) => {
        let value = event.target.value.replace(/\D/g, ""); // Remove non-digit characters
    
        if (value.length > 8) {
            value = value.slice(0, 8); // Restrict length to MMDDYYYY
        }
    
        let formattedValue = "";
    
        // Extract month (MM)
        if (value.length >= 2) {
            let month = value.slice(0, 2);
            if (parseInt(month, 10) > 12) month = "12"; // Restrict to 12
            formattedValue = month;
        } else {
            formattedValue = value;
        }
    
        // Extract day (DD)
        if (value.length >= 4) {
            let day = value.slice(2, 4);
            if (parseInt(day, 10) > 31) day = "31"; // Restrict to 31
            formattedValue += "/" + day;
        } else if (value.length > 2) {
            formattedValue += "/" + value.slice(2);
        }
    
        // Extract year (YYYY)
        if (value.length > 4) {
            let year = value.slice(4, 8);
            formattedValue += "/" + year;
        }
    
        setDob(formattedValue); // Update the state with the formatted value
    };

    
    const formatPhoneNumber = (value) => {
        // Remove all non-numeric characters
        const cleaned = value.replace(/\D/g, '');
        let formatted = cleaned;

        if (cleaned.length >= 1) formatted = `(${cleaned.slice(0, 3)}`;
        if (cleaned.length >= 4) formatted += `)-${cleaned.slice(3, 6)}`;
        if (cleaned.length >= 7) formatted += `-${cleaned.slice(6, 10)}`;

        return formatted;
    };
    
    const validateFields = () => {
        const newErrors = {};

        // Validate first name
        if (!firstName) {
            newErrors.firstName = "First name is required.";
        }

        // Validate last name
        if (!lastName) {
            newErrors.lastName = "Last name is required.";
        }

        // Validate date of birth
        if (!dob) {
            newErrors.dob = "Date of birth is required.";
        }

        // Validate gender
        if (!gender) {
            newErrors.gender = "Gender is required.";
        }

        // Validate mobile number (must be exactly 10 digits)
        const mobileRegex = /^\(\d{3}\)-\d{3}-\d{4}$/;
        if (!mobile) {
            newErrors.mobile = "Mobile number is required.";
        } else if (!mobileRegex.test(mobile)) {
            newErrors.mobile = "Mobile number must be exactly 10 digits.";
        }

        // Validate email (valid email format)
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            newErrors.email = "Email is required.";
        } else if (!emailRegex.test(email)) {
            newErrors.email = "Please enter a valid email address.";
        }

        // Validate verification type
        if (!verification) {
            newErrors.verification = "Verification type is required.";
        }

        return newErrors;
    };
    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };
    
    const handleSubmit = (event) => {
        event.preventDefault();
     
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length === 0) {
            //alert('Registration submitted!');
            if(verification!=null && verification!=''){
                  api.sendOptForVaildation(
                    {
                        dbname: dbname,
                        throug:verification,
                        firstname:firstName,
                        lastname:lastName,
                        mailid:email,
                        mobileno:mobile
                      },
                      (providerRes) => {
                        if (providerRes.status === 200) {
                            const responseData = providerRes.data;
                        
                            if (responseData.includes("Email Send Successfully") || responseData.includes("SMS message sent successfully") ||responseData.includes("Email send Successfully")) {
                                setOtp(responseData.split(":")[0]);  
                                setIsOTPModalOpen(true);
                            } else {
                                setSnackbarMessage("Failed to send OTP.");
                                setSnackbarOpen(true);
                            }
                        } else {
                            setSnackbarMessage("Failed to send OTP.");
                            setSnackbarOpen(true);
                        }
                      }
                  );

            }
            onClose();
        } else {
            setErrors(validationErrors);
            setSnackbarMessage("Please fill all the details which are manditory");
            setSnackbarOpen(true);
        }
    };
    const handleDateChange = (e) => {
        const selectedDate = e.target.value; 
        setDobp(e.target.value);// Default format: yyyy-mm-dd
        const [year, month, day] = selectedDate.split('-'); // Split the date
        const formattedDate = `${month}/${day}/${year}`; // Convert to mm/dd/yyyy
        setDob(formattedDate); // Update state in the desired format
        setErrors({ ...errors, dob: '' }); // Clear validation errors
      };
    const handleOTPVerification = (enteredOtp) => {
        const sanitizedOtp = otp.replace(/^["']+|["']+$/g, '');
        if (String(enteredOtp).trim() === sanitizedOtp.trim()) {
            api.savePatientInfo(dbname,{
                 firstname: firstName,
                 lastname: lastName,
                 dob: dobp,
                 gender: gender,
                 email: email,
                 mobile: mobile,
                 groupId:groupId,
                 absentStatus:absentStatus,
                 sessionId:sessionId,
                 therapyDate:therapyDate,
                 lateReason:lateReason,
                 addToGroup:addToGroup,
             }, (response) => {
                if (response.status === 200 && response.data && response.data!=="null") { 
                    console.log(response.data); // Checks if response.data is not null or undefined
                    setSnackbarMessage('You have registered for the session');
                    setSnackbarOpen(true);
                    resetFields();
                } else {
                    setSnackbarMessage('Failed to add you in the session. Please contact Doctor Office');
                    setSnackbarOpen(true);
                    resetFields();
                }
             });
            setIsOTPModalOpen(false); // Close OTP modal after successful verification
        } else {
            setSnackbarMessage('OTP verification failed');
            setSnackbarOpen(true);
        }
    };
    const handleDateChange1 = (event) => {
        const value = event.target.value;
        if (event.target.id === 'dob1') {
            const isValidDate = /^\d{2}\/\d{2}\/\d{4}$/.test(value);
            if (isValidDate) {
                setDob(value); // Update the text input value
                const [month, day, year] = value.split('/');
                const dateObj = new Date(Date.UTC(year, month - 1, day)); // Create Date object in UTC
                setDobp(dateObj.toISOString().split('T')[0]);
                setError(null); // Update date picker value
            } else {
                setError("Please specifiy valid date");
            }
        }
        
      };
    return (
        <>
        <div className={`registration-modal ${isOpen ? 'open' : ''}`}>
            <div className="registration-modal-content"   ref={modalContentRef} style={{top:(ismobile?'-17%':'0%'),left:(ismobile?'33%':'2.5%'),maxWidth:(ismobile?'500px':'80%')}}>
            <span className="close" onClick={() => { onClose(); resetFields(); }}>&times;</span>
                <h2 style={{margin:'6px',marginTop:'0px',paddingBottom:'2px'}}>Register for session</h2>
                <form onSubmit={handleSubmit}>
                    <label htmlFor="firstName" className="label">First Name: <span className="required">*</span></label>
                    <input 
                        type="text" 
                        id="firstName" 
                        value={firstName} 
                        onChange={(e) => {
                            setFirstName(e.target.value);
                            setErrors({ ...errors, firstName: '' });
                        }} 
                        required 
                    />
                    {errors.firstName && <p className="error">{errors.firstName}</p>}

                    <label htmlFor="lastName" className="label">Last Name: <span className="required">*</span></label>
                    <input 
                        type="text" 
                        id="lastName" 
                        value={lastName} 
                        onChange={(e) => {
                            setLastName(e.target.value);
                            setErrors({ ...errors, lastName: '' });
                        }} 
                        required 
                    />
                    {errors.lastName && <p className="error">{errors.lastName}</p>}
                    <label htmlFor="dob" className="label">
        Date of Birth: <span className="required">*</span>
      </label>
      <div className="dob-container">
      <input
          type="text"
          id="dob1"
          style={{width:ismobile?'91%':'85%'}}
          placeholder='mm/dd/yyyy'
          value={dob}
          onChange={handleTextInputChange} //
          onBlur={handleDateChange1}
          required
        />
        <input
          type="date"
          id="dob"
          style={{width:ismobile?'9%':'15%'}}
          placeholder='mm/dd/yyyy'
          value={dobp}
          onChange={handleDateChange}
          required
        />
        {errors.dob && <p className="error">{errors.dob}</p>}
      </div>
                    <label htmlFor="gender" className="label">Gender: <span className="required">*</span></label>
                    <select 
                        id="gender" 
                        value={gender} 
                        onChange={(e) => {
                            setGender(e.target.value);
                            setErrors({ ...errors, gender: '' });
                        }} 
                        required
                    >
                        <option value="" disabled>Select your gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                    </select>
                    {errors.gender && <p className="error">{errors.gender}</p>}

                    <label htmlFor="mobile" className="label">Mobile No: <span className="required">*</span></label>
                    <input 
                        type="tel" 
                        id="mobile" 
                        value={mobile} 
                        onChange={(e) => {
                            const formattedNumber = formatPhoneNumber(e.target.value);
                            setMobile(formattedNumber);                            
                            setErrors({ ...errors, mobile: '' });
                        }} 
                        maxLength="14"
                        required 
                    />
                    {errors.mobile && <p className="error">{errors.mobile}</p>}

                    <label htmlFor="email" className="label">Email: <span className="required">*</span></label>
                    <input 
                        type="email" 
                        id="email" 
                        value={email} 
                        onChange={(e) => {
                            setEmail(e.target.value);
                            setErrors({ ...errors, email: '' });
                        }} 
                        required 
                    />
                    {errors.email && <p className="error">{errors.email}</p>}

                    <label htmlFor="verification" className="label">Verification Type: <span className="required">*</span></label>
                    <select 
                        id="verification" 
                        value={verification} 
                        onChange={(e) => {
                            setVerification(e.target.value);
                            setErrors({ ...errors, verification: '' });
                        }} 
                        required
                    >
                        <option value="" disabled>Select verification type</option>
                        <option value="sms">SMS</option>
                        <option value="email">Email</option>
                    </select>
                    {errors.verification && <p className="error">{errors.verification}</p>}

                    <button type="submit">Submit</button>
                </form>
            </div>
        </div>
        <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={!!error} onClose={handleCloseSnackbar} message={error} autoHideDuration={6000} />
       {isOTPModalOpen && <OTPModal isOpen={isOTPModalOpen} onClose={() => setIsOTPModalOpen(false)} otp={otp} handleOTPVerification={handleOTPVerification} mob={ismobile} />}
       <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            message={snackbarMessage}
        />
      
       </>
    );
};

export default RegistrationModal;
